import axios from "axios";
import { conf } from "./setBaseUrl";


// let baseUrl= 'http://localhost:9250/smaServer/'
let baseUrl= 'https://www.zzcx.site/smaServer/'


const _http = axios.create({
    baseURL: baseUrl
});
_http.interceptors.request.use(
    config => {

        if ( config.url !== "/login/weixin" && localStorage.getItem("token")) {
            config.headers["X-Access-Token"] = localStorage.getItem("token");
        }

        switch (config.url) {
            case "/system/user/list":
            case "/system/menu/moveMenu":
                config.headers["Content-Type"] =
                    "application/x-www-form-urlencoded;charset=UTF-8";
                break;
            case "/system/common/upload":
            case "/system/user/profile/updatePwd":
            case "/account/changePassword":
            case "/account/sendMessage":
                config.headers["Content-Type"] = "multipart/form-data";
                break;
            default:
                config.headers["Content-Type"] = "application/json;charset=UTF-8";
                break;
        }
        return config;
    },
    error => {
        console.log("request", error);

        return Promise.reject(error);
    }
);

_http.interceptors.response.use(
    response => {
        console.log(response);

        var accessToken = response.headers['X-Access-Token']
        if(accessToken) {
            console.log("accessToken==========="+accessToken)
            localStorage.setItem("token",accessToken) ;
        }

        const responseData = response.data ;

        if(responseData.code == 10003 || responseData.code == 10007) {

            //清除token
            localStorage.removeItem("token");
            //返回登录
            location.reload()
        }
        return response;
    },
    error => {
        console.log("response", error);
        if(error.response.status == 401 ) {
            let host = window.location.origin;
            window.location.replace(host);
        }
        return Promise.reject(error.response.data);
    }
);

async function http(options) {
    const response = await _http(options);

    if (response.status == 200) {
        let result = response.data;
        if (result.data?.token && result.code == 0) {

            //localStorage.setItem("token", result.data.token);
            localStorage.setItem("userName", result.data.name);
            localStorage.setItem("userId", result.data.id);
            localStorage.setItem("userType", result.data.type);
            localStorage.setItem("userLevel", result.data.level);
            localStorage.setItem("userPhone", result.data.phone);
            localStorage.setItem("userAreaId", result.data.areaId);
            localStorage.setItem("userDemoId", result.data.demoId);
            localStorage.setItem("userGridId", result.data.gridId);
            localStorage.setItem("userHospitalId", result.data.hospitalId);

            localStorage.setItem("userObj", JSON.stringify(result.data));
        }
        return result;
    }
    if (response.status == 401) {
        localStorage.removeItem("token");
        let host = window.location.origin;
        window.location.replace(host);
    }
    if (response.status == 200 || response.error == 0) {
        return response.data;
    } else {
        if (response.status == 500) {
            throw new Error(response.error);
        }
    }

}

export default http;
